import {Property as CSSProperty} from 'csstype';
import {Props as SidebarProps} from './Sidebar/Sidebar';

// allowed js styles
export interface LayoutCircleStyles {
  top?: CSSProperty.Top;
  right?: CSSProperty.Right;
  bottom?: CSSProperty.Bottom;
  left?: CSSProperty.Left;
  width?: CSSProperty.Width;
  height?: CSSProperty.Height;
  marginLeft?: CSSProperty.MarginLeft;
  marginTop?: CSSProperty.MarginTop;
  transform?: CSSProperty.Transform;
  transition?: CSSProperty.Transition;
}

export enum LayoutBackground {
  WHITE = 'white',
  GRAY = 'gray',
  ACCENT = 'accent',
  BLUE = 'blue',
  TRANSPARENT = 'transparent',
}

export enum SidebarVariant {
  DARK = 'dark',
  LIGHT = 'light',
}

export interface SidebarPropsExtended extends Omit<SidebarProps, 'partner'> {
  sidebarVariant?: SidebarVariant;
}
